module.exports = __webpack_public_path__ + "img/instruction-icon.516d559f.svg";